<mat-drawer-container class="example-container" autosize>
    <mat-drawer #drawer class="" mode="side">
        <app-menu-mobile></app-menu-mobile>
        <!--        <p>Auto-resizing sidenav</p>-->
        <!--        <p *ngIf="showFiller">Lorem, ipsum dolor sit amet consectetur.</p>-->
        <!--        <button (click)="showFiller = !showFiller" mat-raised-button>-->
        <!--            Toggle extra text-->
        <!--        </button>-->
    </mat-drawer>
    <mat-drawer-content>
        <app-site-header></app-site-header>
        <!--<app-menu></app-menu>-->

        <div style="min-height: 600px;">
            <router-outlet *ngIf="!searchIsActive"></router-outlet>
        </div>
        <!--        <app-product-browser-->
        <!--                [ngClass]="{'visible':searchIsActive,'hidden':!searchIsActive}"></app-product-browser>-->
        <!--<app-image-slider></app-image-slider>-->
        <app-site-footer></app-site-footer>
    </mat-drawer-content>
</mat-drawer-container>
